<template>
  <CustomModal
    class="eligibility-popup-modal"
    :is-modal-open="isOpen"
    @toggleModal="closePopup"
    @onClickAway="closePopup"
    :overlay="'dark'"
    :with-header="true"
    :with-footer="true"
    :custom-classes="'tw:w-[100vw] tw:md:max-w-[500px] tw:md:w-[500px] tw:h-screen tw:md:h-auto tw:md:rounded-md tw:rounded-none'"
  >
    <template #modalHeader>
      <p class="tw:text-xl tw:text-gray-700">{{ $t('app.rateConnect.name') }}</p>
    </template>

    <div class="tw:flex tw:flex-col tw:w-full">
      <p class="tw:mb-5">{{ $t(text) }}</p>
    </div>

    <template #modalFooter>
      <div class="tw:gap-2 tw:w-full tw:flex tw:md:flex-row tw:flex-col tw:md:justify-end">
        <GhostButton class="tw:order-1 tw:md:order-0" @click="closePopup">{{ $t('cancel') }}</GhostButton>
        <MainButton class="tw:order-0 tw:md:order-1" @click="handleAction">{{ $t(buttonLabel) }}</MainButton>
      </div>
    </template>
  </CustomModal>
</template>

<script setup>
import MainButton from '@/components/base/buttons/MainButton.vue'
import GhostButton from '@/components/base/buttons/GhostButton.vue'
import CustomModal from '@/components/base/CustomModal.vue'

import appAnalytics from '@/utils/tracking'

import { selectedAccommodationId } from '@/layouts/queries'

defineProps({
  isOpen: Boolean,
  text: String,
  buttonLabel: String,
})

const emit = defineEmits(['closePopup', 'onAction'])

const closePopup = () => {
  appAnalytics.track(appAnalytics.events.HOMEPAGE_LOCK_ICON_POPUP_CANCELLED, {
    itemId: selectedAccommodationId.value,
  })
  emit('closePopup')
}

const handleAction = () => {
  emit('onAction')
}
</script>
